import React from "react";
import Modal from "react-bootstrap/Modal";

export const ModalChiTiet = ({ show, onHide, item }) => {
  if (!item) {
    return null;
  }
  

  return (
    <>
    <style>
      {`
        .modal-90w {
            max-width: 90% !important; 
          }
      `}
    </style>
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="modal-new modal fade text-left"
      dialogClassName="modal-90w"
    >
      <Modal.Header>
        <h4 className="modal-title color7-bold" id="myModalLabel16">
          <span className="btn-icon-right">
            <i className="fa-solid fa-circle-info"></i>
          </span>
          Chi tiết mẫu hợp đồng
        </h4>
        <button
          type="button"
          className="close-popup-new"
          onClick={onHide}
        >
          <img src="/app-assets/images/icon-dong-popup-v2.png" alt="close" />
        </button>
      </Modal.Header>
      <Modal.Body className="">
        <div className="form form-horizontal">
          <div className="form-body">
            <div className="form-group row">
              <label className="col-md-1 label-control color7-bold">Hợp đồng:</label>
              <div className="col-md-11" style={{ textAlign: "left" }}>
                {item?.ContractName || '---'}
              </div>
            </div>
            <div className="form-group row">
              <label className="col-md-1 label-control color7-bold">Nội dung:</label>
              <div className="col-md-11" style={{ textAlign: "left" }}>
                <div
                  style={{ border: '2px solid #eee', padding: 10, minHeight: 200, borderRadius: '5px', background: '#f8f9fa'}}
                  dangerouslySetInnerHTML={{ __html: item?.ContractContent || '' }}
                />
              </div>
            </div>

          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-new-main btn-closenew"
          onClick={onHide}
        >
          <span>
            <i className="mdi mdi-close"></i>
          </span>
          &nbsp; Đóng
        </button>
      </Modal.Footer>
    </Modal>
    </>
  );
}; 
